/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
8/25/22
Interval View
**********************************************************/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { 
  fetchSeasons, 
  fetchIntervals,
  selectInterval 
} from './interval_actions'
import { 
  Select, 
  CheckBox,
  RadioButton 
} from '../components/inputs'
import IntervalTable from './components/interval_table'
import { packageForm } from "../utils";
const $ = window.$;

class IntervalView extends Component {
  constructor(props) {
    super(props)
    this.onSubmit = this.onSubmit.bind(this)
    $(document).ready(() => {
      $('#interval-choice').tabs();
    });
  }
  componentDidMount() {
    if (this.props.seasons.length === 0) this.props.fetchSeasons()
    if (this.props.intervals.length === 0) {
      this.props.fetchIntervals({
        season: '',
        email: '',
        report: 0
      })
    }
  }
  onSubmit() {
    let form = packageForm('intervalForm')
    if (!form.season) return
    return this.props.fetchIntervals({
      season: form.season,
      email: this.props.user.email,
      report: form.report === 1 ? form.report : 0
    })
  }
  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <form 
            id={'intervalForm'}
            onSubmit={(e) => e.preventDefault()}>
            <div className="col s5 m3 l3 xl3">
              <Select 
                id={'season'} 
                opts={this.props.seasons.map((s) => {
                  return { val: s, label: `Season ${s}` }
                })} 
                label={'Season'}
                defaultValue={this.props.seasons && this.props.seasons[0]} 
              />
            </div>
            <div className="col s6 m3 l3 xl3">
              <div className="row trainer">
                <div className="col s6 m6 l6 xl6">
                  <CheckBox 
                    id={'report'}
                    name={'report'} 
                    label={'Report'}
                  /> 
                </div>
                <div className="col s6 m6 l6 xl6">
                  <button className="btn waves-effect"
                    onClick={this.onSubmit}>
                    Fetch
                  </button>
                </div>
              </div> 
            </div>
          </form>
        </div>
        <div className="row">
          <div className="col s6 m4 l1 xl1">
            <RadioButton 
              id={'kau-interval'} 
              name={'interval-opts'} 
              label={`Ka'u`}
              onClick={(e) => this.props.selectInterval({ 
                interval: this.props.intervals.kau, 
                loc: 71 
              })}
            />
          </div>
          <div className="col s6 m4 l1 xl1">
            <RadioButton 
              id={'keaau-interval'} 
              name={'interval-opts'} 
              label={`Kea'au`}
              onClick={(e) => this.props.selectInterval({ 
                interval: this.props.intervals.keaau, 
                loc: 72
              })}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <ul id="interval-choice" className="tabs tabs-fixed-width">
            <li className="tab col s6">
              <a href="#hand-interval">
                Hand Intervals
              </a>
            </li>
            <li className="tab col s6">
              <a href="#mech-interval">
                Mech Intervals
              </a>
            </li>
          </ul>
          <div className="interval-table">
            <div id="hand-interval">
              <IntervalTable intervals={this.props.selectedInterval.hand} />
            </div>
            <div id="mech-interval">
              <IntervalTable intervals={this.props.selectedInterval.mech} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    user: state.auth.user,
    intervals: state.intervals.intervals,
    seasons: state.intervals.seasons,
    selectedSeason: state.intervals.selectedSeason,
    selectedInterval: state.intervals.selectedInterval
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchSeasons,
    fetchIntervals,
    selectInterval
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(IntervalView);



/* END */



// WEBPACK FOOTER //
// ./src/interval/interval_view.jsx